<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.0002 26.6667H4.00016C3.29292 26.6667 2.61464 26.3857 2.11454 25.8856C1.61445 25.3855 1.3335 24.7072 1.3335 24V2.66667C1.3335 1.95943 1.61445 1.28115 2.11454 0.781048C2.61464 0.280952 3.29292 0 4.00016 0H36.0002C36.7074 0 37.3856 0.280952 37.8858 0.781048C38.3859 1.28115 38.6668 1.95943 38.6668 2.66667V24C38.6668 24.7072 38.3859 25.3855 37.8858 25.8856C37.3856 26.3857 36.7074 26.6667 36.0002 26.6667ZM4.66683 2.66667C4.49002 2.66667 4.32044 2.73691 4.19543 2.86193C4.0704 2.98695 4.00016 3.15652 4.00016 3.33333V23.3333C4.00016 23.5101 4.0704 23.6797 4.19543 23.8048C4.32044 23.9297 4.49002 24 4.66683 24H35.3335C35.5103 24 35.6799 23.9297 35.805 23.8048C35.9299 23.6797 36.0002 23.5101 36.0002 23.3333V3.33333C36.0002 3.15652 35.9299 2.98695 35.805 2.86193C35.6799 2.73691 35.5103 2.66667 35.3335 2.66667H4.66683Z"
      :fill="color"
    />
    <path d="M33.3332 14.6665H18.6665V15.9998H33.3332V14.6665Z" :fill="color" />
    <path d="M30.6665 12H18.6665V13.3333H30.6665V12Z" :fill="color" />
    <path d="M33.3333 5.3335H28V10.6668H33.3333V5.3335Z" fill="#3A8534" />
    <path d="M30.6665 17.3335H18.6665V18.6668H30.6665V17.3335Z" :fill="color" />
    <path
      d="M14.6665 19.9998V6.6665H17.3332V19.9998H14.6665ZM6.6665 19.9998V6.6665H9.33317V19.9998H6.6665ZM9.33317 14.6665V11.9998H14.6665V14.6665H9.33317Z"
      :fill="color"
    />
    <path
      d="M24.6668 24.6665H15.3335V31.3332H24.6668V24.6665Z"
      :stroke="color"
      stroke-width="1.33333"
      stroke-miterlimit="10"
    />
    <path opacity="0.4" d="M24 26.6665H16V29.3332H24V26.6665Z" :fill="color" />
    <path d="M21.3332 30.6665H18.6665V39.9998H21.3332V30.6665Z" :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: "#5C5957",
    },
  },
};
</script>
